"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createServiceThunkMiddleware(extraArgumentFactory) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    var normalizedExtraArgument = extraArgumentFactory(dispatch, getState);
    return _reduxThunk.default.withExtraArgument(normalizedExtraArgument)({
      dispatch: dispatch,
      getState: getState
    });
  };
}

var createServiceThunk = createServiceThunkMiddleware;
var _default = createServiceThunk;
exports.default = _default;